import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider, colors } from '@mui/material';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { Header, Page, PowerBIDashboard } from 'components';
import TableauDashboard, { ShowExportPDFDialog } from '../../../../components/TableauDashboard/TableauDashboard.js';
import OptionsButton from './components/OptionsButton/OptionsButton.js';
import { DashboardInspect as DashboardInspectAction } from '../../actions/DashboardInspectActions.js';
import { DashboardExportPptxRequest } from '../../requests/DashboardInspectRequests.js';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: '100%',
		margin: '0 auto',
		padding: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	divider: {
		backgroundColor: colors.grey[300],
	},
	alert: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
}));

const DashboardInspect = (props) => {
	const { match, pageTitle, headerHidden, module } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const handle = useFullScreenHandle();
	const user = useSelector(state => state.session.user);
	const dashboard = useSelector(state => state.dashboardInspectReducer.dashboard);

	const _getDashboard = () => {
		dispatch(DashboardInspectAction(match.params.id, user.id));
	};

	const _exportPdf = () => {
		ShowExportPDFDialog();
	};

	const _fullScreen = () => {
		handle.enter();
	};

	useEffect(() => {
		_getDashboard();
	}, []);

	const _exportPptx = async () => {
		try {
			const response = await DashboardExportPptxRequest(dashboard.dashboardId, user.id);
			const url = URL.createObjectURL(new Blob([response.data]));
			const a = document.createElement('a');
			a.href = url;
			a.download = `${dashboard.name ?? 'report'}.pptx`;
			a.click();
			URL.revokeObjectURL(url);
		} catch (err) {
			console.error('Export PPTX failed:', err);
		}
	};

	return (
		<Page className={classes.root} title={pageTitle || 'Inspect'}>
			{dashboard.type === 'Tableau' ? (
				<Header
					hidden={headerHidden || false}
					module={module || 'Dashboards'}
					view={dashboard.name ?? 'Inspect'}
					actions={<OptionsButton exportPdf={_exportPdf} fullScreen={_fullScreen} />}
				/>
			) : null}
			{dashboard.type === 'PowerBI' ? (
				<Header
					hidden={headerHidden || false}
					module={module || 'Dashboards'}
					view={dashboard.name ?? 'Inspect'}
					actions={<OptionsButton fullScreen={_fullScreen} />}
					// actions={<OptionsButton fullScreen={_fullScreen} exportPptx={_exportPptx} />}
				/>
			) : null}
			<FullScreen handle={handle}>
				<div className={clsx(classes.content)}>
					{dashboard.type === 'Tableau' ? <TableauDashboard url={dashboard.url} /> : null}
					{dashboard.type === 'PowerBI' ? <PowerBIDashboard url={dashboard.url} reportId={dashboard.serverId} accessToken={dashboard.accessToken} /> : null}
				</div>
			</FullScreen>
		</Page>
	);
};

DashboardInspect.propTypes = {
	match: PropTypes.object.isRequired,
	pageTitle: PropTypes.string,
	headerHidden: PropTypes.bool,
	module: PropTypes.string,
};

export default DashboardInspect;
